import { i18n } from '@fs/zion-locale'

/**
 * Convert a group name into a DGS and item number.
 * e.g. '005102305_005_M931-K62' -> '005102305 (Item 5)'
 * @param {String} groupName e.g. '005102305_005_M931-K62'
 * @returns DGS and item number, e.g. '005102305 (Item 5)'
 */
export default function formatGroupName(groupName) {
  const parts = groupName?.split('_')
  const formattedGroupName = parts?.reduce((acc, cur, i) => {
    if (i === 0) {
      acc = cur
      // eslint-disable-next-line no-restricted-globals
    } else if (i === 1 && isFinite(cur)) {
      // isFinite checks if a string is a valid number https://stackoverflow.com/a/72770816/4151489
      const item = cur.replace(/^0+/, '') // remove leading zeros - e.g. '005' -> '5'
      acc = i18n.t('metisProjects.groupNameWithItem', '{dgs} (Item {item})', { dgs: acc, item })
    } // do nothing for any parts after the first 2
    return acc
  }, '')
  return formattedGroupName || ''
}
